/* eslint-disable no-unused-vars */
// Pipeline V2 LEGACY — se sigue usando para budgets con `version=2.0`
// (creados antes del bump a V3). Los budgets nuevos nacen con `version=3.0`
// y van por `PresupuestoV3/` + TemplateRenderer low-code.
import React, { useEffect, useState } from 'react';
import { Document, Page, View } from '@react-pdf/renderer';
import styles from '../styles';
import BudgetPortrait from '../BudgetPortrait/BudgetPortrait';
import BudgetHeader from '../BudgetHeader/BudgetHeader';
import BudgetFooter from '../BudgetFooter/BudgetFooter';
import BudgetBody from '../BudgetBody/BudgetBody';
import { transformStaticData } from 'utils/formaters';

function BudgetDocument(props) {
  const { budget, items, images, config, staticData, template, templateColors } = props;
  const { idBudget: id, reason, name } = budget;
  const transformedData = transformStaticData(staticData);
  return (
    <Document>
      {/* Página de portada */}
      <Page size="A4" style={styles.portraitPage}>
        <BudgetPortrait id={id} reason={reason} name={name} config={config} />
      </Page>

      {/* Página principal del documento */}
      <Page size="A4" wrap style={styles.page}>
        <BudgetHeader config={config} staticData={transformedData} />
        <View style={styles.bodyPresupuesto}>
          <BudgetBody
            budget={budget}
            items={items}
            images={images}
            config={config}
            staticData={transformedData}
            template={template}
            templateColors={templateColors}
          />
        </View>
        <BudgetFooter config={config} />
      </Page>
    </Document>
  );
}

export default BudgetDocument;
